export function handleSiteModal(element, status) {
  if (!element instanceof HTMLDialogElement) {
	return;
  }
  if (status === "open") {
    if (element.nodeName === "DIALOG" && !element.open) {
      element.showModal();
    } else {
      element.hidden = false;
    }
  } else {
    if (element.nodeName === "DIALOG") {
      element.close();
    } else {
      element.hidden = true;
    }
  }
}

